import React, { useState } from "react"
import { useLoad } from "../../context/useLoadContext"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { useParams } from "react-router-dom"
import { AuthState } from "../../context/usePublicViewContext"
import useLogin from "../../hooks/Components/useLogin"
import { useTranslation } from "react-i18next"
import { companyMemory } from "../../Objects/Memory/Memory"
import Animate, { AnimationTypes } from "../../components/Animate/Animate"
import { getPublicMenuTheme, isLegacyPublicMenuTheme } from "../Helpers/PublicMenuTheme"

interface LoginViewProps {
  onTryLogin: (auth: AuthState) => void
  onGoToSignup: (cpfOrPhone: string) => void
}

const LoginView: React.FC<LoginViewProps> = ({ onTryLogin, onGoToSignup }) => {
  const { restaurantSlug } = useParams<{ restaurantSlug: string }>()

  const { HandleCustomerLogin, setEmail: setCpfOrNumer, setPassword, password, email: cpfOrNumber } = useLogin()

  const [hasLogin, setHasLogin] = useState<boolean>(false)

  const { isLoading } = useLoad()

  const { t } = useTranslation()

  const theme = getPublicMenuTheme(companyMemory)

  const isLegacyTheme = isLegacyPublicMenuTheme(theme)

  const handleCheckAccount = async (e: React.FormEvent) => {
    e.preventDefault()

    await HandleCustomerLogin(API_ROUTES.AUTH.LOGIN_CUSTOMER(restaurantSlug), (authState: AuthState) => {
      if (!authState.status) {
        onGoToSignup(cpfOrNumber)
      } else {
        onTryLogin(authState)
      }
    })

    return

    /*await handleCheckIfHasCustomer(
      email,
      (result: boolean) => {
        setHasLogin(result)

        if (!result) {
          setCurrentView(EAppView.SigupView)
        }
      },
      API_ROUTES.CUSTOMER.HAS_CUSTOMER_PUBLIC(restaurantSlug),
    )*/
  }

  const handleTryLogin = async (e: React.FormEvent) => {
    /*e.preventDefault()

    await HandleCustomerLogin(API_ROUTES.AUTH.LOGIN_PUBLIC(restaurantSlug), (result: boolean) => {
      setHasLogin(result)

      if (!result) {
        setCurrentView(EAppView.SigupView)
      }
    })*/
  }

  return (
    <Animate type={AnimationTypes.fadeInTraslate}>
      <div className="max-w-md mx-auto sm:mt-0 animate-in fade-in slide-in-from-top-4 duration-700">
        <div
          className="bg-white rounded-2xl border border-gray-100 shadow-[0_40px_100px_rgba(0,0,0,0.08)] overflow-hidden"
          style={
            isLegacyTheme
              ? undefined
              : {
                  backgroundColor: theme.surfaceColor,
                  borderColor: theme.borderColor,
                  borderWidth: theme.borderThickness,
                  color: theme.textColor,
                }
          }
        >
          <div
            className="bg-white p-10 text-center relative overflow-hidden"
            style={
              isLegacyTheme
                ? undefined
                : {
                    background: theme.useGradientHeader
                      ? `linear-gradient(135deg, ${theme.headerBackgroundColor} 0%, ${theme.surfaceColor} 55%, ${theme.backgroundColor} 100%)`
                      : theme.headerBackgroundColor,
                  }
            }
          >
            <div className="relative z-10 flex flex-col items-center">
              {companyMemory.iconUrl.length > 0 ? (
                <img
                  src={companyMemory.iconUrl.toClientRequest()}
                  alt="Logo da empresa"
                  className="w-16 h-16 rounded-2xl flex items-center justify-center mb-6"
                />
              ) : (
                <div
                  className="w-14 h-14 bg-orange-600 rounded-2xl flex items-center justify-center mb-6 shadow-xl shadow-orange-600/20 rotate-3"
                  style={isLegacyTheme ? undefined : { backgroundColor: theme.primaryColor }}
                >
                  <svg className="w-7 h-7 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2.5"
                      d="M12 11c0 3.517-1.009 6.799-2.753 9.571m-3.44-2.04l.054-.09A10.003 10.003 0 0012 3a10.003 10.003 0 008.384 4.562M9 21h6m-3-11a3 3 0 11-6 0 3 3 0 016 0z"
                    />
                  </svg>
                </div>
              )}

              <h2
                className="text-3xl font-black text-black-800 tracking-tight leading-none mb-2"
                style={isLegacyTheme ? undefined : { color: theme.restaurantNameColor }}
              >
                {companyMemory.companyName.length > 0 ? companyMemory.companyName : t("publicMenu:login.title")}
              </h2>

              <p
                className="text-[14px] text-gray-400 font-bold uppercase tracking-[0.2em]"
                style={isLegacyTheme ? undefined : { color: theme.restaurantDescriptionColor }}
              >
                {t("publicMenu:login.subtitle")}
              </p>
            </div>
          </div>

          <div
            className="p-5 space-y-5"
            style={isLegacyTheme ? undefined : { backgroundColor: theme.surfaceColor }}
          >
            <form onSubmit={hasLogin ? handleTryLogin : handleCheckAccount} className="space-y-5">
              <div className="space-y-2">
                <div className="flex justify-between items-center px-2">
                  <label
                    className="text-[10px] font-black text-gray-600 uppercase "
                    style={isLegacyTheme ? undefined : { color: theme.textColor }}
                  >
                    {t("publicMenu:login.cpf_or_mobile")}
                  </label>
                </div>

                <div className="relative group">
                  <input
                    type="number"
                    required
                    disabled={hasLogin}
                    value={cpfOrNumber}
                    onChange={(e) => setCpfOrNumer(e.target.value)}
                    placeholder="000.000.000-00"
                    className="w-full px-8 py-4 rounded-2xl bg-gray-50 border-2 border-gray-500 focus:border-orange-600 focus:bg-white focus:ring-4 focus:ring-orange-600/5 outline-none transition-all font-black text-gray-950 text-center text-xl tracking-tight shadow-inner placeholder:text-gray-4000"
                    style={
                      isLegacyTheme
                        ? undefined
                        : {
                            backgroundColor: theme.searchBackgroundColor,
                            borderColor: theme.searchBorderColor,
                            color: theme.textColor,
                          }
                    }
                    data-interaction-description-key="interactionDescriptions:publicMenu.pages.loginView.input.input"
                  />
                </div>

                {hasLogin && (
                  <div className="relative group">
                    <input
                      type="password"
                      required
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      placeholder={t("publicMenu:login.password_placeholder")}
                      className="w-full px-8 py-4 rounded-2xl bg-gray-50 border-2 border-gray-500 focus:border-orange-600 focus:bg-white focus:ring-4 focus:ring-orange-600/5 outline-none transition-all font-black text-gray-950 text-center text-xl tracking-tight shadow-inner placeholder:text-gray-4000"
                      style={
                        isLegacyTheme
                          ? undefined
                          : {
                              backgroundColor: theme.searchBackgroundColor,
                              borderColor: theme.searchBorderColor,
                              color: theme.textColor,
                            }
                      }
                      data-interaction-description-key="interactionDescriptions:publicMenu.pages.loginView.input.passwordPlaceholder"
                    />
                  </div>
                )}
              </div>

              <button
                disabled={isLoading || !cpfOrNumber}
                className="w-full h-18 py-5 bg-orange-600 hover:bg-orange-500 text-white rounded-2xl font-black text-xs uppercase tracking-[0.25em] shadow-[0_20px_40px_rgba(234,88,12,0.25)] active:scale-[0.97] transition-all disabled:opacity-60 disabled:grayscale flex items-center justify-center gap-4 group"
                style={
                  isLegacyTheme ? undefined : { backgroundColor: theme.buttonColor, color: theme.buttonTextColor }
                }
                data-interaction-description-key="interactionDescriptions:publicMenu.pages.loginView.button.continue"
              >
                {isLoading ? (
                  <div className="w-5 h-5 border-4 border-white/30 border-t-white rounded-full animate-spin" />
                ) : (
                  <>
                    <span>{!hasLogin ? t("publicMenu:login.continue") : t("publicMenu:login.title")}</span>

                    <svg
                      className="w-4 h-4 group-hover:translate-x-1 transition-transform"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                    </svg>
                  </>
                )}
              </button>
            </form>

            <div className="flex flex-col items-center gap-4">
              <div className="flex items-center gap-3 w-full">
                <div className="flex-1 h-px bg-gray-100" style={isLegacyTheme ? undefined : { backgroundColor: theme.borderColor }} />

                <span
                  className="text-[9px] font-black text-gray-400 uppercase tracking-widest"
                  style={isLegacyTheme ? undefined : { color: theme.textColor, opacity: 0.6 }}
                >
                  {t("publicMenu:login.signup_prompt")}
                </span>

                <div className="flex-1 h-px bg-gray-100" style={isLegacyTheme ? undefined : { backgroundColor: theme.borderColor }} />
              </div>
              <button
                onClick={() => onGoToSignup(cpfOrNumber)}
                className="px-8 py-3 text-[11px] font-black text-gray-950 uppercase tracking-widest border-2 border-gray-100 rounded-2xl hover:border-gray-950 transition-colors active:scale-95"
                style={
                  isLegacyTheme
                    ? undefined
                    : { borderColor: theme.borderColor, color: theme.textColor, backgroundColor: theme.surfaceColor }
                }
                data-interaction-description-key="interactionDescriptions:publicMenu.pages.loginView.button.onGoToSignupCpfOrNumber"
              >
                {t("publicMenu:login.create_account")}
              </button>
            </div>
          </div>

          <div
            className="bg-gray-50 py-4 text-center"
            style={isLegacyTheme ? undefined : { backgroundColor: theme.secondaryColor }}
          >
            <p
              className="text-[8px] font-black text-gray-400 uppercase tracking-[0.35em]"
              style={isLegacyTheme ? undefined : { color: theme.textColor, opacity: 0.6 }}
            >
              {t("publicMenu:login.security_footer")}
            </p>
          </div>
        </div>
      </div>
    </Animate>
  )
}

export default LoginView
